// CustomTimePicker.tsx
import React from "react";
import "./CustomTimePicker.css";

interface CustomTimePickerProps {
  value: string; // expected format "HH:MM"
  onChange: (time: string) => void;
  step?: number; // minute step
}

const CustomTimePicker: React.FC<CustomTimePickerProps> = ({
  value,
  onChange,
  step = 1,
}) => {
  const [hours, minutes] = value ? value.split(":") : ["", ""];

  const handleHourChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newHour = e.target.value.padStart(2, "0");
    onChange(`${newHour}:${minutes || "00"}`);
  };

  const handleMinuteChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newMinute = e.target.value.padStart(2, "0");
    onChange(`${hours || "00"}:${newMinute}`);
  };

  return (
    <div className="custom-time-picker">
      <select value={hours} onChange={handleHourChange} className="ctp-select">
        {Array.from({ length: 12 }, (_, i) => (
          <option key={i} value={String(i + 1).padStart(2, "0")}>
            {String(i + 1).padStart(2, "0")}
          </option>
        ))}
      </select>
      :
      <select
        value={minutes}
        onChange={handleMinuteChange}
        className="ctp-select"
      >
        {Array.from({ length: 60 / step }, (_, i) => {
          const val = String(i * step).padStart(2, "0");
          return (
            <option key={val} value={val}>
              {val}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default CustomTimePicker;
